import type {ChartXAxisOptions, ChartYAxisOptions, PlotOptions} from '../types'

export const SERIES_DASH_STYLES = [
  'Solid',
  'ShortDash',
  'Dot',
  'DashDot',
  'LongDash',
  'ShortDashDotDot',
  'ShortDot',
  'LongDashDot',
  'Dash',
  'ShortDashDot',
  'LongDashDotDot',
]

export const SYMBOLS = ['circle', 'square', 'diamond', 'triangle', 'triangle-down']

export const UNICODE_SYMBOLS_CONVERTED = {
  circle: '\u25CF',
  square: '\u25A0',
  diamond: '\u25C6',
  triangle: '\u25B2',
  'triangle-down': '\u25BC',
}
// abbreviated month followed by the day (no leading zero before days 1-9)
const DEFAULT_DATE_TIME_FORMAT = '{value:%b %e}'

const getDefaultFormat = (type: string | undefined) => (type === 'datetime' ? DEFAULT_DATE_TIME_FORMAT : undefined)

export const getXAxisOptionWithDefaults = (xAxisOption?: ChartXAxisOptions) => {
  if (xAxisOption === undefined) {
    return undefined
  }

  const title = xAxisOption.title

  return {
    ...xAxisOption,
    labels: {
      format: getDefaultFormat(xAxisOption.type),
      ...xAxisOption.labels,
    },
    title: {
      text: title,
    },
  }
}

export const getYAxisOptionsWithDefaults = (yAxisOptions?: ChartYAxisOptions | ChartYAxisOptions[]) => {
  if (yAxisOptions === undefined) {
    return undefined
  }

  // convert yAxisOptions to an array if it is not already an array
  const array = Array.isArray(yAxisOptions) ? yAxisOptions : [yAxisOptions]

  // map over yAxisOptions and add default format to labels
  return array.map(yAxisOption => {
    const title = yAxisOption.title

    return {
      ...yAxisOption,
      labels: {
        format: getDefaultFormat(yAxisOption.type),
        ...yAxisOption.labels,
      },
      title: {
        text: title,
      },
    }
  })
}

export const getDataWithDefaults = (data: Highcharts.SeriesOptionsType[], type?: string) => {
  return (data ?? []).map((s, index) => {
    const dashStyle = SERIES_DASH_STYLES[index % SERIES_DASH_STYLES.length]
    // only set default dashStyle if it is not already set
    return {
      type,
      dashStyle,
      marker: {
        symbol: SYMBOLS[index % SYMBOLS.length],
      },
      ...s,
    }
  })
}

// Default values for plotOptions
// - marker: false
// - dataLabel: false
// - lineWidth: 2
export const getTransformedPlotOptions = (plotOptions?: PlotOptions, marker?: boolean, labels?: boolean) => {
  const defaultPlotOptions = {
    marker: {enabled: marker ?? false},
    dataLabel: {enabled: labels ?? false},
    lineWidth: 2,
  }

  return {
    series: {...plotOptions, ...defaultPlotOptions},
  } as Highcharts.PlotOptions
}
